export enum LocalStorageKey {
  REFERRAL = 'referral',
  SIGNUP_SOURCE = 'signup_source',
}
